import { makeAutoObservable } from "mobx";
import { Pools, RwaPools } from "../types/types";
import { useRef } from "react";

class PoolsStore {
  formDataCrypto: Pools = {};
  formDataRWA: RwaPools = {};
  error: string | null = null;
  formDataPools: { [key: string]: any } = {
    coin: "",
    period: "",
    мatchAssets: "",
    amount: "",
    agreeConditions: "",
    autoSubscribe: "true",
    dateTime: "",
    predictDateTime: "",
    selectedProcent: "",
    walletAdress: "",
    qrHash: "",
    minValue: "",
    predictAmount: "",
  };
  isSubscribe: boolean | undefined = undefined;
  isConfirm: Number | undefined = undefined;
  invalidInputs: { [key: string]: boolean } = {};
  dataValid: boolean | undefined = false;
  isLoading: boolean = false;
  formRef: HTMLDivElement | null = null;
  periods: {
    period: string;
    apy: string;
    minPurchaseAmount: string;
    maxPurchaseAmountPerUser: string;
  }[] = [];
  hitsSteps: number = 1;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchDataDurationCrypto() {
    this.isLoading = true;
    this.error = null;

    try {
      const response = await fetch(
        "/api/v1/pool/currencies",
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Error fetching data");
      }

      const data: Pools = await response.json();
      this.formDataCrypto = data;
    } catch (error) {
      this.error = "error message";
    } finally {
      this.isLoading = false;
    }
  }

  async fetchDataDurationRWA() {
    this.isLoading = true;
    this.error = null;

    try {
      const response = await fetch("/api/v1/pool/rwa", {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Error fetching data");
      }

      const data: RwaPools = await response.json();
      this.formDataRWA = data;
    } catch (error) {
      this.error = "error message";
    } finally {
      this.isLoading = false;
    }
  }

  updateField(name: string, value: string | boolean) {
    this.formDataPools[name] = value;
  }

  setDataValid(component: boolean | undefined) {
    this.dataValid = component;
  }

  setIsSubscribe(component: boolean | undefined) {
    this.isSubscribe = component;
  }

  validateFields() {
    const newInvalidInputs: { [key: string]: boolean } = {};

    if (!this.formDataPools.agreeConditions) {
      newInvalidInputs.agreeConditions = true;
    }

    if (
      !this.formDataPools.amount ||
      isNaN(parseFloat(this.formDataPools.amount)) ||
      parseFloat(this.formDataPools.amount) <
        parseFloat(this.formDataPools.minValue) ||
      parseFloat(this.formDataPools.amount) === 0
    ) {
      newInvalidInputs.amount = true;
    }

    if (!this.formDataPools.walletAdress) {
      newInvalidInputs.walletAdress = true;
    }

    this.invalidInputs = newInvalidInputs;
    return Object.values(newInvalidInputs).every((isValid) => !isValid);
  }

  setIsConfirm(component: Number | undefined) {
    this.isConfirm = component;
  }

  setHitsStepPlus() {
    this.hitsSteps = this.hitsSteps + 1;
  }

  setHitsStepMinus() {
    this.hitsSteps = this.hitsSteps - 1;
  }

  setHitsStepZero() {
    this.hitsSteps = 0;
  }

  setHitsStepNumber(number: number) {
    this.hitsSteps = number;
  }
}

const poolsStore = new PoolsStore();
export default poolsStore;
